import React from "react"
import styled from "styled-components"
import PropTypes from "prop-types"

export const StyledButton = styled.button`
  background-color: ${props => (props.secondary ? "transparent" : "#474dc4")};
  border-radius: 8px;
  letter-spacing: 0.5px;
  text-align: center;
  color: ${props => (props.sameColor ? "#474dc4" : "#fff")};
  font-size: 24px;
  font-family: "Made Medium", sans-serif;
  padding: 12px 0;
  outline: 0;
  transition: 0.2s ease;
  cursor: pointer;
  text-decoration: none;
  border: ${props => (props.secondary ? "2px solid #474dc4" : "none")};
  &:disabled {
    background-color: ${props => (props.secondary ? "transparent" : "#dedede")};
    color: #000;
    border: ${props => (props.secondary ? "2px solid #dedede" : "none")};
    &:hover {
      transform: scale(1);
    }
  }
  &:hover {
    transform: scale(1.06);
  }
  @media (min-width: 1024px) {
    padding: 9px 0;
  }
`

const Button = ({ children, secondary, sameColor, type, disabled }) => {
  return (
    <StyledButton
      type={type}
      secondary={secondary}
      sameColor={sameColor}
      disabled={disabled}
    >
      {children}
    </StyledButton>
  )
}

export default Button

Button.propTypes = {
  children: PropTypes.string.isRequired,
  type: PropTypes.string,
  secondary: PropTypes.bool,
  sameColor: PropTypes.bool,
  disabled: PropTypes.bool,
}

Button.defaultProps = {
  secondary: false,
  sameColor: false,
  disabled: false,
  type: "button",
}
